import React from 'react'
import styled from 'styled-components'

import TitleHeader from 'components/presenters/header/TitleHeader'

export default function PointPolicyLayout() {
  return (
    <PointPolicyPage>
      <TitleHeader title={'포인트 정책 안내'} />

      <PointPolicyContent>
        <Title>{'제 20조(포인트)'}</Title>

        <Body>
          <Paragraph>
            {
              '① 포인트는 회사가 정한 절차와 방식, 사용기한 등의 조건에 따라 사용이 가능하며, 회사의 정책에 따라 변경될 수 있습니다.'
            }
          </Paragraph>
          <Paragraph>
            {
              '② 포인트는 제공일로부터 180일 간 유효(개별 정책이나 게시 내용에 달리 정한 경우 그에 따릅니다)하고, 미 사용 시 적립된 순서에 따라 소멸됩니다.'
            }
          </Paragraph>
          <Paragraph>
            {
              '③ 포인트를 사용하여 결제한 유료서비스에 대한 취소, 환불이 이루어지는 경우, 결제에 사용된 포인트는 복구됩니다. 단, 취소, 환불 시점에 포인트의 사용기간이 경과하지 않아야 합니다.'
            }
          </Paragraph>
          <Paragraph>
            {
              '④ 포인트는 회사에서 별도로 명시한 경우를 제외하고는 타인에게 양도할 수 없으며, 부정한 목적이나 용도로 사용할 수 없습니다. 이를 위반한 경우 회사는 포인트를 소멸시키거나 회원자격을 정지할 수 있습니다.'
            }
          </Paragraph>
          <Paragraph>
            {
              '⑤ 회원이 부정한 방법으로 포인트를 획득한 사실이 확인될 경우 회사는 회원의 포인트 회수, 서비스 이용계약의 해지, 민, 형사 고발 등의 법적조치를 취할 수 있습니다.'
            }
          </Paragraph>
        </Body>
      </PointPolicyContent>
    </PointPolicyPage>
  )
}

const PointPolicyPage = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
`

const PointPolicyContent = styled.div`
  margin-top: calc(100vw * (51 / 375));
  height: calc(100vh - calc(100vw * (51 / 375)));
  overflow-y: scroll;
  padding: 0 calc(100vw * (16 / 375));
`

const Title = styled.div`
  font-weight: 600;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (28 / 375));
  color: #121212;
  margin-top: calc(100vw * (17 / 375));
  margin-left: calc(100vw * (6 / 375));
  margin-bottom: calc(100vw * (8 / 375));
`

const Body = styled.div`
  padding: calc(100vw * (14 / 375)) calc(100vw * (16 / 375)) calc(100vw * (20 / 375));
  background-color: #f7f7f7;
  border-radius: calc(100vw * (21 / 375));
  margin-bottom: calc(100vw * (44 / 375));
`

const Paragraph = styled.p`
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (24 / 375));
  color: #121212;
  margin-bottom: calc(100vw * (18 / 375));
  word-break: keep-all;

  &:last-child {
    margin-bottom: none;
  }
`
